/*eslint-disable*/
import React from "react";
import { useState } from "react";
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';

import * as Scroll from 'react-scroll';
import {Link} from 'react-scroll';

// @material-ui/core components
import { Popover, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// core components
import Button from "components/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import "./headerLinks.scss";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  var scroll = Scroll.animateScroll;
  const scrollToBottom = () => {
    scroll.scrollToBottom();
  };
  const [anchor, setAnchor] = useState(null);
  const openPopover = (event) => {
    setAnchor(event.currentTarget);
  };
  
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <div
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
          >
            <Link
              to="about"
              spy={true} 
              smooth={true} 
              duration={500} 
              offset={-60}
            >
              About me
            </Link>
          </Button>
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <div
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
          >
            <Link
              to="portfolio"
              spy={true} 
              smooth={true} 
              duration={500} 
              offset={-60}
            >
              projects
            </Link>
          </Button>
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <div
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
          >
            <Link
              to="skills"
              spy={true} 
              smooth={true} 
              duration={500} 
              offset={-60}
            >
              skills
            </Link>
          </Button>
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <div
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
          >
            <Link
              to="resume"
              spy={true} 
              smooth={true} 
              duration={500} 
              offset={-60}
            >
              Experience
            </Link>
          </Button>
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-twitter"
          title="Find me on LinkedIn"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://www.linkedin.com/in/qirui-wu-6b4724205/"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <LinkedInIcon></LinkedInIcon>
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Find me on Github"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://github.com/hhdqirui"
            target="_blank"
            className={classes.navLink}
          >
            <GitHubIcon></GitHubIcon>
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          title="Email me"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            target="_blank"
            className={classes.navLink}
            onClick={openPopover}
          >
            <EmailIcon></EmailIcon>
          </Button>
        </Tooltip>
        <Popover
            open={Boolean(anchor)}
            anchorEl={anchor}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
            onClose={() => setAnchor(null)}
          >
            <Typography 
              className="typo"
              variant="h6"
              style={{
                padding: "10px 15px",
                minWidth: "130px",
                color: "#555555",
                lineHeight: "1.7em",
                background: "#FFFFFF",
                border: "none",
                borderRadius: "3px",
                boxShadow:
                  "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
                maxWidth: "200px",
                textAlign: "center",
                fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                fontSize: "1.5em",
                fontStyle: "normal",
                fontWeight: "400",
                textShadow: "none",
                textTransform: "none",
                letterSpacing: "normal",
                wordBreak: "normal",
                wordSpacing: "normal",
                wordWrap: "normal",
                whiteSpace: "normal",
                lineBreak: "auto",
              }}
            >Email me at <a href="mailto:hhdqirui@gmail.com">hhdqirui@gmail.com</a></Typography>
          </Popover>
      </ListItem>
    </List>
    // <List className={classes.list}>
    //   <ListItem className={classes.listItem}>
    //     <div
    //       placement={window.innerWidth > 959 ? "top" : "left"}
    //       classes={{ tooltip: classes.tooltip }}
    //     >
    //         <Button
    //           to="about"
    //           spy={true} 
    //           smooth={true} 
    //           duration={500} 
    //           offset={-60}
    //         >
    //         </Button>
    //     </div>
    //   </ListItem>
    // </List>
  );
}
